// extracted by mini-css-extract-plugin
module.exports = {"cookieConsent":"CookieConsent_cookieConsent__hrQHf","cookieConsentContent":"CookieConsent_cookieConsentContent__ibqmA"};